import gql from 'graphql-tag';
import { UserAllDataFragment } from '../fragments';

export default gql`
query me {
    me {
        ...UserAllDataFragment
    }
}
${UserAllDataFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/me.ts